<div class="order-success-container">
    <h1>{{ "Axilla.Webshop.FieldAgent.OrderSubmitted" | localize }}</h1>
    <h4>{{ "Axilla.Webshop.FieldAgent.OrderSubmitted.ThankYou" | localize}}</h4>
    <h4>{{ "Axilla.Webshop.FieldAgent.OrderSubmitted.RecieveOrder" | localize }}</h4>

    <div class="p-d-flex p-jc-around p-align-center p-mt-4">
        <div class="p-d-flex p-jc-around p-align-center">
            <button class="btn btn-primary" (click)="backToMyAccount()">{{"CustomersList" | localize}}</button>
            <button class="btn btn-primary" (click)="newOrder()">{{"NewOrder" | localize}}</button>
        </div>
    </div>
</div>
